import { Fields, YesObject } from '@yes.technology/react-toolkit'

const REGEX_PATTERN = /\{\{([^\}]+)\}\}/g

export interface ConcatFields {
  [fieldname: string]: string
}

export function concatenateField(object: YesObject, sourcemap: string): string {
  return sourcemap.replace(REGEX_PATTERN, (match, p1) => {
    const keys = p1.split('.')
    const value = getValueFromObject(object, keys)
    if (value !== undefined) {
      return value
    }
    return ''
  })
}

function getValueFromObject(
  obj: YesObject,
  keys: string[]
): string | undefined {
  let value: any = obj
  for (const key of keys) {
    if (value?.[key] !== undefined) {
      value = value[key]
    } else {
      return undefined
    }
  }
  return typeof value === 'string' ? value : undefined
}

export function concatenateFields(
  concatFields: ConcatFields,
  yesObject: YesObject
) {
  return Object.keys(concatFields || {}).reduce((acc, fieldname) => {
    if (concatFields[fieldname]) {
      return {
        ...acc,
        [fieldname]: concatenateField(yesObject, concatFields[fieldname])
      }
    }
    return acc
  }, yesObject)
}

export const concatenateDisplayText = ({
  concatFields,
  fields,
  columnName
}: {
  concatFields?: ConcatFields
  fields?: Fields
  columnName: string
}) => {
  const concatColumnPattern = concatFields?.[columnName]

  return (
    concatColumnPattern?.replace(REGEX_PATTERN, (substring, keys) => {
      const key = keys.split('.')[0]
      return fields?.[key]?.display_text.des || ''
    }) || fields?.[columnName]?.display_text.des
  )
}

export const extractFieldsFromConcatFields = (
  concatFields?: Record<string, string>,
  currentFields?: string[]
): string[] => {
  if (!concatFields || Object.keys(concatFields).length === 0) return []

  const result = new Set<string>()

  for (const pattern of Object.values(concatFields)) {
    const matches = pattern.match(REGEX_PATTERN)
    if (!matches) continue

    for (const match of matches) {
      const key = match.slice(2, -2)
      if (result.has(key)) continue

      const splitted = key.split('.').map((k) => k.trim())
      const mainKey = splitted[0]
      const attribute = splitted[splitted.length - 1]

      let formattedKey = mainKey

      if (attribute !== mainKey) {
        formattedKey += `.${attribute}`
      }

      if (!(currentFields ?? [])?.includes(mainKey)) {
        result.add(formattedKey)
      }
    }
  }

  return Array.from(result)
}
